import * as z from 'zod';
import '../../../financial-formula/adjustable-value.mjs';
import { AdjustableValuesUpdate } from '../../../financial-formula/adjustable-values-update.mjs';
import '../../../financial-formula/adjustment.mjs';
import '../../../financial-formula/formula.mjs';
import '@inrev/core';
import { lineItemLabelSchema } from './line-item-group.mjs';

const incomeStatementDirectFieldKeys = [
    "cogs",
    "operatingExpenses",
    "otherIncome",
    "otherExpenses",
    "taxes",
    "depreciation",
    "amortization",
    "depreciationAndAmortization",
    "interestExpense",
    "incomeTaxes",
    "irregularGainLossFromAssetSale",
    "distributions",
];
const incomeStatementDirectFieldKeySchema = z.enum(incomeStatementDirectFieldKeys);
var IncomeStatementDirectFieldKey;
(function (IncomeStatementDirectFieldKey) {
    IncomeStatementDirectFieldKey.schema = incomeStatementDirectFieldKeySchema;
})(IncomeStatementDirectFieldKey || (IncomeStatementDirectFieldKey = {}));
var IncomeStatementRevenueLineItemLabel;
(function (IncomeStatementRevenueLineItemLabel) {
    IncomeStatementRevenueLineItemLabel.schema = lineItemLabelSchema;
})(IncomeStatementRevenueLineItemLabel || (IncomeStatementRevenueLineItemLabel = {}));
var IncomeStatementRevenueLineItemRef;
(function (IncomeStatementRevenueLineItemRef) {
    IncomeStatementRevenueLineItemRef.schema = z
        .object({
        field: z.literal("revenue"),
        label: lineItemLabelSchema,
    })
        .strict();
})(IncomeStatementRevenueLineItemRef || (IncomeStatementRevenueLineItemRef = {}));
var IncomeStatementDirectFieldRef;
(function (IncomeStatementDirectFieldRef) {
    IncomeStatementDirectFieldRef.schema = z
        .object({
        field: incomeStatementDirectFieldKeySchema,
    })
        .strict();
})(IncomeStatementDirectFieldRef || (IncomeStatementDirectFieldRef = {}));
var IncomeStatementFieldRef;
(function (IncomeStatementFieldRef) {
    IncomeStatementFieldRef.schema = z.discriminatedUnion("field", [
        IncomeStatementRevenueLineItemRef.schema,
        IncomeStatementDirectFieldRef.schema,
    ]);
})(IncomeStatementFieldRef || (IncomeStatementFieldRef = {}));
var IncomeStatementRevenueLineItemUpdate;
(function (IncomeStatementRevenueLineItemUpdate) {
    IncomeStatementRevenueLineItemUpdate.schema = IncomeStatementRevenueLineItemRef.schema.extend({
        values: AdjustableValuesUpdate.schema,
    });
})(IncomeStatementRevenueLineItemUpdate || (IncomeStatementRevenueLineItemUpdate = {}));
var IncomeStatementDirectFieldUpdate;
(function (IncomeStatementDirectFieldUpdate) {
    IncomeStatementDirectFieldUpdate.schema = IncomeStatementDirectFieldRef.schema.extend({
        values: AdjustableValuesUpdate.schema,
    });
})(IncomeStatementDirectFieldUpdate || (IncomeStatementDirectFieldUpdate = {}));
var IncomeStatementFieldUpdate;
(function (IncomeStatementFieldUpdate) {
    IncomeStatementFieldUpdate.schema = z.discriminatedUnion("field", [
        IncomeStatementRevenueLineItemUpdate.schema,
        IncomeStatementDirectFieldUpdate.schema,
    ]);
})(IncomeStatementFieldUpdate || (IncomeStatementFieldUpdate = {}));
const isIncomeStatementDirectFieldKey = (value) => incomeStatementDirectFieldKeys.includes(value);

export { IncomeStatementDirectFieldKey, IncomeStatementDirectFieldRef, IncomeStatementDirectFieldUpdate, IncomeStatementFieldRef, IncomeStatementFieldUpdate, IncomeStatementRevenueLineItemLabel, IncomeStatementRevenueLineItemRef, IncomeStatementRevenueLineItemUpdate, incomeStatementDirectFieldKeys, isIncomeStatementDirectFieldKey };
